import React, { useState } from "react";

import Icon from "@bonprix/pattern-library/templates/icon";

export default function Hint({
  className,
  hasCloser = false,
  onCloserClick,
  attributes = {},
  children = {},
}) {
  const [open, setOpen] = useState(true);

  const onClose = () => {
    setOpen(false);
    if (onCloserClick) {
      onCloserClick();
    }
  };

  if (open) {
    return (
      <div className={className} {...attributes}>
        {children}
        {hasCloser ? (
          <div className="hint__close-icon" onClick={onClose}>
            <Icon name="closer" />
          </div>
        ) : null}
      </div>
    );
  }

  return null;
}
